import React from 'react';
import { connect } from 'react-redux';
import { fetchMarketsWheel, setMarketSelected } from '../../actions';
import { setVal, changeValue } from '../../actions';
import DynamicText from './DynamicText';
import {Link} from 'react-router-dom';
import {splitLines, sectorDetails} from '../../helpers/Utils';


class MarketWheel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      marketLists: [], //this.props.marketswheel,
      width: 200,
      position9_X: 0,
      position9_Y: 0,
      position8_X: 0,
      position8_Y: 0,
      position7_X: 0,
      position7_Y: 0,
      position6_X: 0,
      position6_Y: 0,
      position5_X: 0,
      position5_Y: 0,
      position4_X: 0,
      position4_Y: 0,
      position3_X: 0,
      position3_Y: 0,
      position2_X: 0,
      position2_Y: 0,
      position1_X: 0,
      position1_Y: 0,
      selectedMarket: '',
      selectedDefinition: 0,
      selectedWheelPosition:0
    };

    this.OnPositionClick = this.OnPositionClick.bind(this);
    this.marketClicked = this.marketClicked.bind(this);
  }

  onChangeLinkName = (newX, newY) => {
    this.setState({
      position9_X: newX,
      position9_Y: newY
    });
  }

  onChangeLinkName8 = (newX, newY) => {
    this.setState({
      position8_X: newX,
      position8_Y: newY
    });
  }
  onChangeLinkName7 = (newX, newY) => {
    this.setState({
      position7_X: newX,
      position7_Y: newY
    });
  }

  onChangeLinkName6 = (newX, newY) => {
    this.setState({
      position6_X: newX,
      position6_Y: newY
    });
  }
  onChangeLinkName5 = (newX, newY) => {
    this.setState({
      position5_X: newX,
      position5_Y: newY
    });
  }
  onChangeLinkName4 = (newX, newY) => {
    this.setState({
      position4_X: newX,
      position4_Y: newY
    });
  }
  onChangeLinkName3 = (newX, newY) => {
    this.setState({
      position3_X: newX,
      position3_Y: newY
    });
  }
  onChangeLinkName2 = (newX, newY) => {
    this.setState({
      position2_X: newX,
      position2_Y: newY
    });
  }
  onChangeLinkName1 = (newX, newY) => {
    this.setState({
      position1_X: newX,
      position1_Y: newY
    });
  }


  renderTitle() {
    let tmpItem;

    tmpItem = this.props.period;

    return tmpItem;

  }

  renderRegion() {
    let tmpItem;
    tmpItem = "Select A";// (this.props.region === "Global") ? 'Key Global' : this.props.region;
    return tmpItem;

  }
  hasMarkets(position) {
    return this.getMarketsByPosition(position).length > 0 ? true : false;
  }

  getMarketsByPosition(position) {

    let myData = "";
    this.props.marketswheel.forEach(element => {

      if (parseInt(element.position) === position) {
        if (element.market.length > 0) {
          if (myData.length > 0) {
            myData += "|";
          }
          myData += element.market;
        }

      }
    });

    return myData;
  }
  renderMarketName()
  {
   
    let name = this.props.marketselected.trim();

    
    let lineHeight = 0.15;
    let textFont = "15px futura-pt";
    if(name.length >20)
    {
      return splitLines(name, textFont, 150, lineHeight, 90)
    }
    else
    {
      return name;
    }

  }

  renderAreaOnCycle()
  {
    let areaOnCycle ='';
    this.props.marketswheel.forEach(element => {

      if ((element.market) === this.props.marketselected.trim()) {
        if (element.market.length > 0) {
          areaOnCycle= element.areaOnCycle;
      }

      }
    });
    let lineHeight = 1.15;
    let textFont = "15px futura-pt";
    if(areaOnCycle.length >30)
    {
        return splitLines(areaOnCycle, textFont, 180, lineHeight,95);
    }
    else
    {
      return areaOnCycle;
    }
    
  }

  fetchMarketInfo(market){
    market = market.trim();
    let region = '';
    let greaterRegion = '';

    this.props.marketswheel.find((x) => {
      if (x.market === market){
        region = x.region
        greaterRegion = x.greaterRegion
      }
      return null;
    })

    this.props.setMarketSelected({greaterRegion, region, market});
  }

  marketClicked(e, filler, position)
  {
   let marketbg = document.getElementById('Market-info');   

   if(marketbg)
   {
   marketbg.setAttribute("fill", filler);
   }
 
  //setting 10 as id for showing Market details in the center
  let currentSelectedMarket = e;
  let updatedSelection=10;
  let updatedWheelPosition;

  if(currentSelectedMarket.trim() === this.props.marketselected.trim() )
  {
    updatedSelection = parseInt(position);
    currentSelectedMarket='';
    updatedWheelPosition = parseInt(position)
  }
  else
  {
    updatedSelection = 10;
    currentSelectedMarket =e;
    updatedWheelPosition = parseInt(position)
  }

  this.fetchMarketInfo(e);

  this.setState({
    selectedDefinition: (updatedSelection),
    selectedMarket: currentSelectedMarket,
    selectedWheelPosition : (updatedWheelPosition)
  });

  this.props.xyz(currentSelectedMarket.trim(), position);
  this.props.setVal(updatedSelection, updatedWheelPosition)
 }

  componentDidMount() {
      this.props.fetchMarketsWheel();
      // This code is to set the background color of the inner circle as we navigate back from detail page.
      if(this.props.selectedWheelPosition !== 0)
      {
        var sectordetails = sectorDetails(this.props.selectedWheelPosition)
        
        //let marketbg = document.getElementById('Market-info-background');
        let marketbg = document.getElementById('Market-info');

        if(marketbg)
        {
        marketbg.setAttribute("fill", sectordetails.sectorColor);
        }

      }

  }

   OnPositionClick(e) {   
    
    let currentSelection = parseInt(e.target.id.match(/\d/)[0]);

    let updatedSelection = (currentSelection === this.props.selectedDefinition ? 0 : currentSelection);
    
    this.props.setVal(updatedSelection, updatedSelection)
    this.props.xyz('', 0);
    e.stopPropagation();
  }

  render() {

    let transform_Pos9 = "";
    let transform_Pos8 = "";
    let transform_Pos7 = "";
    let transform_Pos6 = "";
    let transform_Pos5 = "";
    let transform_Pos4 = "";
    let transform_Pos3 = "";
    let transform_Pos2 = "";
    let transform_Pos1 = "";

    transform_Pos9 = "translate(" + this.state.position9_X + ", " + this.state.position9_Y + ")";
    transform_Pos8 = "translate(" + this.state.position8_X + ", " + this.state.position8_Y + ")";
    transform_Pos7 = "translate(" + this.state.position7_X + ", " + this.state.position7_Y + ")";
    transform_Pos6 = "translate(" + this.state.position6_X + ", " + this.state.position6_Y + ")";
    transform_Pos5 = "translate(" + this.state.position5_X + ", " + this.state.position5_Y + ")";
    transform_Pos4 = "translate(" + this.state.position4_X + ", " + this.state.position4_Y + ")";
    transform_Pos3 = "translate(" + this.state.position3_X + ", " + this.state.position3_Y + ")";
    transform_Pos2 = "translate(" + this.state.position2_X + ", " + this.state.position2_Y + ")";
    transform_Pos1 = "translate(" + this.state.position1_X + ", " + this.state.position1_Y + ")";

    const styles = {
      marketLists: {
        width: 200
      },
      range: {
        marginLeft: 25,
        width: 275
      },
      svg: {
        height: 125,
        display: 'block',
        border: '3px solid #aaa',
        marginBottom: 10,
        overflow: 'visible'
      }
    }

    let height = '100%';
    if(window.navigator.userAgent.indexOf('Trident') !== -1) {
      height = '800px';
    }

    return (

      <svg width="1138" height="928" viewBox="0 0 1138 928" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Desktop">

<g id="Desktop - Default">
<path id="Wedge_1" d="M430.177 235.489C471.58 211.584 518.546 199 566.354 199C614.162 199 661.128 211.584 702.531 235.489L637.454 348.206C615.837 335.725 591.315 329.154 566.354 329.154C541.393 329.154 516.871 335.725 495.254 348.206L430.177 235.489Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 1 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`} />
<path id="Wedge_4" d="M702.531 707.219C661.128 731.124 614.162 743.708 566.354 743.708C518.546 743.708 471.58 731.123 430.177 707.219L495.254 594.502C516.871 606.983 541.393 613.554 566.354 613.554C591.315 613.554 615.837 606.983 637.454 594.502L702.531 707.219Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 4 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`}/>
<path id="Wedge_3" d="M838.708 471.354C838.708 519.162 826.124 566.128 802.219 607.531C778.315 648.934 743.934 683.315 702.531 707.219L637.454 594.502C659.071 582.022 677.022 564.071 689.502 542.454C701.983 520.837 708.554 496.315 708.554 471.354H838.708Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 3 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`} />
<path id="Wedge_2" d="M702.531 235.489C743.934 259.393 778.315 293.774 802.22 335.177C826.124 376.58 838.708 423.546 838.708 471.354L708.554 471.354C708.554 446.393 701.983 421.871 689.503 400.254C677.022 378.637 659.071 360.686 637.454 348.206L702.531 235.489Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 2 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`}  />
<path id="Wedge_6" d="M294 471.354C294 423.546 306.584 376.58 330.489 335.177C354.393 293.774 388.774 259.392 430.177 235.488L495.254 348.205C473.637 360.686 455.686 378.637 443.206 400.254C430.725 421.871 424.154 446.393 424.154 471.354L294 471.354Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 6 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`}  />
<path id="Wedge_5" d="M430.177 707.219C388.774 683.315 354.392 648.934 330.488 607.531C306.584 566.128 294 519.162 294 471.354L424.154 471.354C424.154 496.315 430.725 520.837 443.205 542.454C455.686 564.071 473.637 582.022 495.254 594.502L430.177 707.219Z" fill="#CAD1D3" stroke="white" stroke-width="2" onClick={this.OnPositionClick} className={`${this.props.selectedWheelPosition === 5 ? "rent-position-on cursor-pointer" : "rent-position-off cursor-pointer"}`} />


<g id="Position-6-markets" transform={transform_Pos6} className={`${this.hasMarkets(6) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>
<svg width="100%" style={styles.svg}>
  <DynamicText position="6" onChangeLink6={this.onChangeLinkName6} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(6)} >

  </DynamicText>
</svg>
</g>


<g id="Position-5-markets" transform={transform_Pos5} className={`${this.hasMarkets(5) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>
  <svg width="100%" style={styles.svg}>
  <DynamicText position="5" onChangeLink5={this.onChangeLinkName5} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(5)} >

  </DynamicText>
</svg>

</g>

<g id="Position-4-markets" transform={transform_Pos4} className={`${this.hasMarkets(4) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>
<svg width="100%" style={styles.svg}>
  <DynamicText position="4" onChangeLink4={this.onChangeLinkName4} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(4)} >

  </DynamicText>
</svg>
</g>

<g id="Position-3-markets" transform={transform_Pos3} className={`${this.hasMarkets(3) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>
<svg width="100%" style={styles.svg}>
  <DynamicText position="3" onChangeLink3={this.onChangeLinkName3} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(3)} >

  </DynamicText>
</svg>      

</g>

<g id="Position-2-markets" transform={transform_Pos2} className={`${this.hasMarkets(2) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>  
<svg width="100%" style={styles.svg}>
  <DynamicText position="2" onChangeLink2={this.onChangeLinkName2} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(2)} >

  </DynamicText>
</svg>      
</g>

<g id="Position-1-markets" transform={transform_Pos1} className={`${this.hasMarkets(1) === true ? "show-element markets-at-spoke-level" : "hide-element markets-at-spoke-level"}`}>
<svg width="100%" style={styles.svg}>
  <DynamicText position="1" onChangeLink1={this.onChangeLinkName1} x="0" y="0.71em" width={this.state.width} marketClicked = {this.marketClicked} markets = {this.getMarketsByPosition(1)} >

  </DynamicText>
</svg>      
</g>


<text id="RentCycleWheelPosition_1" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
	<tspan id="RentCycleWheelPosition_1" x="510" y="275" onClick={this.OnPositionClick}>Rents at Peak</tspan>
</text>

<text id="RentCycleWheelPosition_3" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
	<tspan id="RentCycleWheelPosition_3" x="697" y="566" onClick={this.OnPositionClik}>Rent Decline </tspan>
	<tspan id="RentCycleWheelPosition_3" x="697" y="586" onClick={this.OnPositionClick}>Slowing</tspan>
</text>

<text id="RentCycleWheelPosition_4" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
	<tspan id="RentCycleWheelPosition_4" x="499" y="683" onClick={this.OnPositionClick}>Rents at Trough</tspan>
</text>

<text id="RentCycleWheelPosition_5" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
	<tspan id="RentCycleWheelPosition_5" x="348" y="553" onClick={this.OnPositionClick}>Rent </tspan>
	<tspan id="RentCycleWheelPosition_5" x="348" y="573" onClick={this.OnPositionClick}>Growth </tspan><tspan x="348" y="593">Accelerating</tspan>
</text>

<text id="RentCycleWheelPosition_6" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
<tspan id="RentCycleWheelPosition_6" x="331" y="378" onClick={this.OnPositionClick}>Rent Growth </tspan>
<tspan id="RentCycleWheelPosition_6" x="331" y="398" onClick={this.OnPositionClick}>Slowing</tspan>
</text>

<text id="RentCycleWheelPosition_2" className="cursor-pointer" fill="#ffffff" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" font-weight="500" letter-spacing="0em" onClick={this.OnPositionClick}>
	<tspan id="RentCycleWheelPosition_2" x="710" y="358.467" onClick={this.OnPositionClick}>Rent </tspan>
	<tspan id="RentCycleWheelPosition_2" x="710" y="378.467" onClick={this.OnPositionClick}>Decline </tspan>
	<tspan id="RentCycleWheelPosition_2" x="710" y="398.467" onClick={this.OnPositionClick}>Accelerating</tspan>
</text>

<g id="Market-info" className={`${this.props.selectedDefinition === 10 ? "show-element" : "hide-element"}` }>
<text id="Market_name" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="20" letter-spacing="0em">
<tspan x={this.props.marketselected.length >10 ? '500.967':'530.967'} y="461.5">  {this.renderMarketName()}
</tspan>
</text>
	<g id="Link">
  <Link to={`${this.props.basepath}/marketdetail?market=${this.props.marketselected.trim()}`} className="viewdetail-selected-bold" id= {`rentcyclemarketname-${this.props.marketselected.trim() }`} >
		<line id="Line 11" x1="507" y1="490.5" x2="537" y2="490.5" stroke="#17E88F" stroke-width="2"/>
		<text id="Learn More" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="18" font-weight="500" letter-spacing="-0.02em">
      <tspan x="547" y="494.2">Learn More</tspan>
    </text>
    </Link>
	</g>
</g>

<g id="Spokes_3">

	<g id="Spoke_13 Pos1" className={`${this.hasMarkets(1) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_13" cx="567" cy="171" r="11" fill="#CAD1D3" className={`${this.props.selectedWheelPosition === 1 ? "rent-position-on-line" : ""}`}/>
	<line id="Line 10_13" x1="567" y1="181.276" x2="567" y2="201" stroke="#CAD1D3" stroke-width="4" className={`${this.props.selectedWheelPosition === 1 ? "spokepositonlineon" : ""}`}/>
	</g>
	<g id="Spoke_14 Pos4" className={`${this.hasMarkets(4) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_14" cx="567" cy="772" r="11" transform="rotate(180 567 772)" fill="#CAD1D3" className={`${this.props.selectedWheelPosition === 4 ? "rent-position-on-line" : ""}`}/>
	<line id="Line 10_14" x1="567" y1="761.724" x2="567" y2="742" stroke="#CAD1D3" stroke-width="4" className={`${this.props.selectedWheelPosition === 4 ? "spokepositonlineon" : ""}`}/>
	</g>
	<g id="Spoke_15 Pos2" className={`${this.hasMarkets(2) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_15" cx="828.481" cy="324.026" r="11" transform="rotate(60 828.481 324.026)" className={`${this.props.selectedWheelPosition === 2 ? "rent-position-on-line" : ""}`} fill="#CAD1D3"/>
	<line id="Line 10_15" x1="819.581" y1="329.164" x2="802.5" y2="339.026" stroke="#CAD1D3" stroke-width="4" className={`${this.props.selectedWheelPosition === 2 ? "spokepositonlineon" : ""}`}/>
	</g>
	<g id="Spoke_16 Pos3" className={`${this.hasMarkets(3) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_16" cx="827.481" cy="620.526" r="11" transform="rotate(120 827.481 620.526)" fill="#CAD1D3" className={`${this.props.selectedWheelPosition === 3 ? "rent-position-on-line" : ""}`}/>
	<line id="Line 10_16" x1="818.581" y1="615.388" x2="801.5" y2="605.526" stroke="#CAD1D3" stroke-width="4" className={`${this.props.selectedWheelPosition === 3 ? "spokepositonlineon" : ""}`}/>
	</g>
	<g id="Spoke_17 Pos5" className={`${this.hasMarkets(5) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_17" cx="305.026" cy="620.526" r="11" transform="rotate(-120 305.026 620.526)" fill="#CAD1D3" className={`${this.props.selectedWheelPosition === 5 ? "rent-position-on-line" : ""}`} />
	<line id="Line 10_17" x1="313.926" y1="615.388" x2="331.007" y2="605.526" stroke="#CAD1D3" stroke-width="4" className={`${this.props.selectedWheelPosition === 5 ? "spokepositonlineon" : ""}`}/>
	</g>
	<g id="Spoke_18 Pos6" className={`${this.hasMarkets(6) === true ? "show-element" : "hide-element"}`}>
	<circle id="Ellipse 11_18" cx="305.026" cy="322.026" r="11" transform="rotate(-60 305.026 322.026)" fill="#CAD1D3" className={`${this.props.selectedWheelPosition === 6 ? "rent-position-on-line" : ""}`}/>
	<line id="Line 10_18" x1="313.926" y1="327.164" x2="331.007" y2="337.026" stroke="#CAD1D3" className={`${this.props.selectedWheelPosition === 6 ? "spokepositonlineon" : ""}`} stroke-width="4"/>
	</g>
</g>


<g id="Definition - Rental Growth Slowing" className={`${this.props.selectedDefinition === 6 ? "show-element" : "hide-element"}`}>
<text id="Rental Growth Slowing_4" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="24" letter-spacing="0em">
<tspan x="457" y="425.6">Rent Growth Slowing</tspan>
</text>
<text id="The rate of rental growth has slowed compared to past 6-12 months. Rents are not yet at their peak, and are expected to grow further, but at a slower rate." fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
	<tspan x="457" y="458.4">The rate of rent growth has slowed</tspan>
	<tspan x="457" y="480.4">from the past six to 12 months. Rents</tspan>
	<tspan x="457" y="502.4">have not yet peaked and are expected</tspan>
	<tspan x="457" y="529.4">to increase at a slower rate.</tspan>

</text>
</g>

<g id="Definition - Rental Growth Accelerating" className={`${this.props.selectedDefinition === 5 ? "show-element" : "hide-element"}`}>
<text id="Rental Growth Accelerating_4" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="24" letter-spacing="0em">
	<tspan x="463" y="422.6">Rent Growth </tspan>
	<tspan x="463" y="452.6">Accelerating</tspan>
</text>
<text id="Rents have started to increase, and the rate of growth is expected to accelerate over the next 6-12 months." fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
	<tspan x="463" y="485.4">Rents are rising and the rate of </tspan>
	<tspan x="463" y="507.4">increase is expected to accelerate </tspan>
	<tspan x="463" y="529.4">over the next six to 12 months.</tspan>

</text>
</g>

<g id="Definition - Rents at Trough" className={`${this.props.selectedDefinition === 4 ? "show-element" : "hide-element"}`}>
<text id="Rents at Trough_4" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="24" letter-spacing="0em">
<tspan x="471" y="417.6">Rents at Trough</tspan>
</text>
<text id="Rents are at their trough. Market may show some upcoming recovery signals and the next movement is expected to be an increase." fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
	<tspan x="471" y="450.4">Rents are at their trough and the</tspan>
	<tspan x="471" y="472.4">next movement is expected to be </tspan>
	<tspan x="471" y="494.4">an increase.</tspan>

</text>
</g>

<g id="Definition - Rental Decline Slowing" className={`${this.props.selectedDefinition === 3 ? "show-element" : "hide-element"}`}>
<text id="Rental Decline Slowing_4" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="24" letter-spacing="0em">
<tspan x="463" y="426.6">Rent Decline Slowing</tspan>
</text>
<text id="The rate of rental decline has slowed compared to past 6-12 months." fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
	<tspan x="463" y="459.4">The rate of rent decline has slowed</tspan>
	<tspan x="463" y="481.4">from the past six to 12 months. </tspan>
	<tspan x="463" y="503.4">Rents have not yet bottomed out </tspan>
	<tspan x="463" y="525.4">and are expected to decline at </tspan>
	<tspan x="463" y="547.4">a slower rate.</tspan>

</text>
</g>

<g id="Definition - Rental Decline Accelerating" className={`${this.props.selectedDefinition === 2 ? "show-element" : "hide-element"}`}>
<text id="Rental Decline Accelerating_4" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="24" letter-spacing="0em">
	<tspan x="472" y="411.6">Rent Decline </tspan>
	<tspan x="472" y="441.6">Accelerating</tspan>
</text>
<text id="Rents have started to fall, and the rate of decline is expected to accelerate over the next 6-12 months." fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
	<tspan x="472" y="474.4">Rents are falling and the rate of </tspan>
	<tspan x="472" y="496.4">decline is expected to accelerate </tspan>
	<tspan x="472" y="518.84">over the next six to 12 months.</tspan>

</text>
</g>

<g id="Definition - Rents at Peak" className={`${this.props.selectedDefinition === 1 ? "show-element" : "hide-element"}`}>
<text id="Rents at Peak_4" fill="#435254" xmlSpace="preserve" style={styles.svg} 
font-family="Calibre" font-size="24" letter-spacing="0em">
<tspan x="468" y="417.6">Rents at Peak</tspan>
</text>
<text id="Rents are at their peak and are considered to have reached plateau." 
fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="16" letter-spacing="0em">
<tspan x="468" y="450.4">Rents have reached a peak plateau. </tspan>
<tspan x="468" y="472.4">Marginal further growth is still </tspan>
<tspan x="468" y="494.4">possible, while a significant decline</tspan>
<tspan x="468" y="516.4">is not yet expected.</tspan>

</text>
</g>
<g id="Definition - Placeholder" className={`${this.props.selectedDefinition === 0 ? "show-element market-wheel-inside-default-text" : "hide-element market-wheel-inside-default-text"}`}>
<text id="Select a market to view more details" fill="#435254" xmlSpace="preserve" style={styles.svg} font-family="Calibre" font-size="22" letter-spacing="0em">
<tspan x="467.586" y="463.8">Select a market to view </tspan><tspan x="514.443" y="496.8">more details</tspan></text>
</g>
</g>
</g>
</svg>
);
  }
}

const mapStateToProps = (state) => {

  return {
    period: state.activePeriod,
    region: state.greaterRegions,
    marketswheel: state.marketswheel,
    selectedDefinition: state.selectedWheelPosition.selectedDefinition,
    selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition,
    marketselected: state.marketselected,
    basepath : state.basepath
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMarketsWheel: () => {
      dispatch(fetchMarketsWheel())
    },
    xyz: (marketid, positionid) => {
      dispatch(changeValue(marketid, positionid))
    },
    setVal: (selectedDefinition, selectedPosition ) => {
      dispatch(setVal(selectedDefinition, selectedPosition))
    },
    setMarketSelected: (selection) => dispatch(setMarketSelected(selection))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketWheel);
